import React from "react"
import DocumentTitle from "react-document-title"
import createReactClass from "create-react-class"
import * as shared from "auth/component/shared"
import * as client from "auth/client"
import * as form from "shared/validate"
import {ERROR_MESSAGES} from "shared/validate"
import assign from "object-assign"
import * as userShared from "util/person"
import Code_, {codePattern} from "shared/klass-code"
import {ContinueWithClever, ContinueWithGoogle, ContinueWithClassLink} from "shared/oauth"
import {PrimaryOutlineButton} from "../../../components/buttons"
import Avatar from "../../../components/avatar"
import {Chip} from "../../../components/chips"
import {ErrorMessage} from "../../../components/inputs"
import {getAvatar} from "shared/avatar"

const hrStyles = {
  border: "none",
  backgroundColor: "#efefef",
  color: "#efefef",
  height: "2px",
  margin: "0 auto",
  maxWidth: "352px"
}

const createOAuthState = (code) => (!code ? null : btoa(`klass_code=${code}&operation=student/join-class`))

const Code = createReactClass({
  getInitialState() {
    return {
      submitAttempted: false,
      validationErrors: {},
      statusAnnouncement: ""
    }
  },
  componentDidMount() {
    // Ensure first input is focused when component mounts
    // The Code_ component's auto-focus logic has a bug, so we handle it here
    setTimeout(() => {
      if (this.codeComponent && this.codeComponent.focusCodeput) {
        this.codeComponent.focusCodeput(0)
      }
    }, 100)
  },
  onContinue(e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({submitAttempted: true})

    if (!this.props.allowContinue) {
      this.showValidationErrors()
      return
    }

    this.props.completeCode()
  },
  showValidationErrors() {
    const validationErrors = {}

    // Only show generic validation error if no code has been entered
    // If a code was entered but not found, the Code_ component already handles the error
    const hasCodeEntered = this.props.codeFromParams && this.props.codeFromParams.length === 6

    if (!this.props.allowContinue && !hasCodeEntered) {
      validationErrors.code = "Please enter a 6-digit class code to continue."
      this.setState({
        validationErrors,
        statusAnnouncement: "Please enter a class code to continue."
      })

      // Clear the code inputs and focus the first input for better accessibility
      if (this.codeComponent) {
        setTimeout(() => {
          // Clear the code inputs by resetting to default state
          if (this.codeComponent.setState) {
            this.codeComponent.setState({
              code: Array(6).fill(null),
              klass: null
            })
          }
          // Focus the first input
          if (this.codeComponent.focusCodeput) {
            this.codeComponent.focusCodeput(0)
          }
        }, 100)
      }

      // Clear the announcement after delay
      setTimeout(() => {
        this.setState({statusAnnouncement: ""})
      }, 1000)
    } else {
      // Clear any existing validation errors if code was entered but not found
      // (let the Code_ component handle the "not found" messaging)
      this.setState({validationErrors: {}})
    }
  },
  onCodeChange(...args) {
    // Clear errors when user types
    this.setState({validationErrors: {}})
    if (this.props.onSetCode) {
      this.props.onSetCode(...args)
    }
  },
  onCodeInputKeyDown(e) {
    // Handle Enter key from code input fields only, not from buttons
    if (e.key === "Enter" && e.target.tagName === "INPUT") {
      e.preventDefault()
      if (this.props.allowContinue) {
        // Auto-submit when class is found
        this.props.completeCode()
      } else {
        // Show validation error when inputs are empty/invalid
        this.onContinue(e)
      }
    }
  },
  onFetchedKlass(klass) {
    // Enhanced status announcements for screen readers
    if (klass) {
      if (typeof klass === "object") {
        this.setState({
          statusAnnouncement: `Class found: ${klass.name}`
        })
      }
    } else {
      this.setState({
        statusAnnouncement: "Class code not found. Please check and try again."
      })

      // Focus the "Try again" link for better accessibility when class not found
      setTimeout(() => {
        const tryAgainLink = document.querySelector('a[href="#"]')
        if (tryAgainLink && tryAgainLink.textContent && tryAgainLink.textContent.includes("Try again")) {
          tryAgainLink.focus()
        }
      }, 200)
    }

    // Call the original onFetchedKlass prop
    if (this.props.onFetchedKlass) {
      this.props.onFetchedKlass(klass)
    }

    // Clear announcement after delay
    setTimeout(() => {
      this.setState({statusAnnouncement: ""})
    }, 2000)
  },
  render() {
    const props = {
      ...this.props,
      onSetCode: this.onCodeChange,
      onFetchedKlass: this.onFetchedKlass,
      validationError: this.state.validationErrors.code
    }
    return (
      <shared.Subscreen className="code">
        {/* ARIA live region for status announcements */}
        <div role="status" aria-live="polite" className="sr-only">
          {this.state.statusAnnouncement}
        </div>
        <div className="grid gap-y-4">
          <shared.H2>Please enter your class code.</shared.H2>
          <shared.Explanation>
            Enter the six-digit code (e.g. &quot;AAA111&quot;) your teacher provides to ensure you're joining the right class. Ask your teacher if you don't have one yet.
          </shared.Explanation>
        </div>
        <div onKeyDown={this.onCodeInputKeyDown}>
          <Code_
            {...props}
            ref={(ref) => {
              this.codeComponent = ref
            }}
          />
        </div>
        <div className="grid gap-y-4">
          <shared.Button onClick={this.onContinue} pressOnEnter={true}>
            Continue
          </shared.Button>
          <div className="overline-sm">OR</div>
          <ContinueWithClever actionType="signup" state={createOAuthState(this.props.codeFromParams)} />
          <ContinueWithClassLink actionType="signup" state={createOAuthState(this.props.codeFromParams)} />
        </div>
      </shared.Subscreen>
    )
  }
})

const Klass = ({klass, onCancel}) => {
  const handleCancel = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onCancel()
  }

  const handleKeyDown = (e) => {
    // Standard button behavior: respond to both Space and Enter
    if (e.key === "Enter" || e.key === " ") {
      handleCancel(e)
    }
  }

  return (
    <div className="klass">
      <Chip className="hover:bg-neutral-20">
        <div className="flex gap-x-3 items-center h-full">
          <span>{`${klass.name}: ${klass.code}`}</span>
          <button onClick={handleCancel} onKeyDown={handleKeyDown} type="button">
            <span className="sr-only">Cancel class code entered</span>
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path
                d="M1.39819 9.35582C1.14819 9.35582 0.898192 9.25582 0.698192 9.05582C0.298191 8.68082 0.298191 8.03082 0.698192 7.65582L3.57674 4.75227L0.688426 1.83834C0.288426 1.46334 0.295313 0.819824 0.695313 0.444824C1.07031 0.0448245 1.71343 0.0383397 2.08843 0.438339L5.00174 3.32727L7.90786 0.446152C8.28286 0.0461522 8.93285 0.0461522 9.30785 0.446152C9.70785 0.821152 9.70785 1.47115 9.30785 1.84615L6.42674 4.75227L9.30769 7.65823C9.70769 8.03323 9.70769 8.68323 9.30769 9.05823C9.10769 9.25823 8.85769 9.35823 8.60769 9.35823C8.35769 9.35823 8.10769 9.25823 7.90769 9.05823L5.00174 6.17727L2.09819 9.05582C1.89819 9.25582 1.64819 9.35582 1.39819 9.35582Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      </Chip>
    </div>
  )
}

const withSignup = (Component, validateForm, defaultProps) =>
  createReactClass({
    getInitialState() {
      return {
        isUsernameUnique: null,
        username: null,
        password: null,
        language: "en",
        shake: false,
        submitting: false,
        submitAttempted: false,
        validationErrors: {}
      }
    },
    _isSubmitting: false, // Synchronous flag to prevent double submission
    
    resetSubmissionFlag() {
      this._isSubmitting = false
    },
    
    setName(name) {
      const validationErrors = {...this.state.validationErrors}
      delete validationErrors.name
      this.setState({name, validationErrors})
    },
    setUsername(username) {
      const validationErrors = {...this.state.validationErrors}
      delete validationErrors.username
      this.setState({username, isUsernameUnique: null, validationErrors})
    },
    setPassword(password) {
      const validationErrors = {...this.state.validationErrors}
      delete validationErrors.password
      this.setState({password, validationErrors})
    },
    setLanguage(e) {
      this.setState({language: e.target.value})
    },
    checkUniqueUsername() {
      const {username} = this.state
      if (username) {
        client.validateUniqueUsername(username, (err, resp) => {
          if (err) {
            throw new Error("Unknown error on validating username:" + err)
          }
          this.setState({isUsernameUnique: resp.body})
        })
      }
    },
    onComplete(e) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }

      // Prevent double submission using synchronous flag
      if (this._isSubmitting) {
        return
      }
      this._isSubmitting = true

      this.setState({submitAttempted: true})

      const state = this.state
      const errors = validateForm(state)

      // If there are any basic validation errors (empty fields, format issues), show them all at once
      if (form.anyErrors(errors)) {
        this.resetSubmissionFlag()
        this.showValidationErrors(errors)
        return
      }

      // If username format is valid but uniqueness hasn't been checked yet, check it
      // This ensures Enter key has same behavior as onBlur
      if (state.username && state.isUsernameUnique === null) {
        this.resetSubmissionFlag()
        this.checkUniqueUsername()
        return // Prevent submission until uniqueness is checked
      }

      // If username is not unique, prevent submission
      if (state.isUsernameUnique === false) {
        this.resetSubmissionFlag()
        return
      }
      // Clear both uniqueness errors AND validation errors during submission
      this.setState({
        submitting: true, 
        isUsernameUnique: null,
        validationErrors: {} // Clear all validation errors during submission
      })
      this.props.onComplete(state, (newState) => {
        this.resetSubmissionFlag()
        if (newState) {
          this.setState(assign({submitting: false}, newState))
        } else {
          this.setState({submitting: false})
        }
      })
    },
    showValidationErrors(errors) {
      // Use the shared utility from our earlier work
      const validationErrors = shared.mapErrorsToMessages(errors)
      
      this.setState({validationErrors}, () => {
        // Focus first error field after validation errors are set
        this.focusFirstErrorField(errors)
      })
    },
    focusFirstErrorField(systemErrors) {
      const validationErrors = this.state.validationErrors || {}
      const isMinorForm = !systemErrors.name // Minor form doesn't have name field
      
      const baseSelectors = {
        username: '#username-input',
        password: '#password-input'
      }
      
      const fieldConfig = {
        fieldOrder: isMinorForm ? ['username', 'password'] : ['name', 'username', 'password'],
        fieldSelectors: isMinorForm ? baseSelectors : { name: '#name-input', ...baseSelectors },
        uniqueFieldKey: 'username'
      }
      
      shared.focusFirstErrorField(validationErrors, systemErrors, fieldConfig)
    },
    toggleShake(shake) {
      this.setState({shake})
    },
    render() {
      const state = this.state
      const errors = validateForm(state)
      const {showGoogle, userType} = defaultProps
      const hasValidationErrors = state.validationErrors && Object.keys(state.validationErrors).length > 0
      return (
        <shared.SignupForm
          onContinue={this.onComplete}
          submitting={state.submitting}
          shake={state.shake}
          showGoogle={showGoogle}
          userType={userType}
          submitAttempted={state.submitAttempted}
          validationErrors={state.validationErrors}
          hasFormErrors={form.anyErrors(errors) || hasValidationErrors}
        >
          <Component
            {...assign({}, this.props, {
              setLanguage: this.setLanguage,
              setPassword: this.setPassword,
              setUsername: this.setUsername,
              setName: this.setName,
              checkUniqueUsername: this.checkUniqueUsername,
              signup: state,
              errors: {isUsernameUnique: state.isUsernameUnique === false ? ERROR_MESSAGES.NON_UNIQUE_USERNAME : null},
              onComplete: this.onComplete,
              toggleShake: this.toggleShake,
              validationErrors: state.validationErrors
            })}
          />
        </shared.SignupForm>
      )
    }
  })

const Minor_ = ({setUsername, checkUniqueUsername, errors, setPassword, setLanguage, onComplete, validationErrors}) => (
  <div className="grid gap-y-6">
    <shared.UsernameInput 
      setValue={setUsername} 
      onBlur={checkUniqueUsername} 
      onEnter={onComplete}
      customError={errors.isUsernameUnique} 
      validationError={validationErrors && validationErrors.username}
    />
    <shared.PasswordInput 
      setValue={setPassword} 
      onEnter={onComplete}
      validationError={validationErrors && validationErrors.password}
    />
    <shared.SelectLanguage onChange={setLanguage} />
  </div>
)

const Minor = withSignup(Minor_, form.validateMinorStudentSignupForm, {showGoogle: false})

const Major_ = ({setName, setUsername, checkUniqueUsername, errors, setPassword, setLanguage, onComplete, validationErrors}) => (
  <div className="grid gap-y-6">
    <shared.NameInput
      setValue={setName}
      onEnter={onComplete}
      maxLength={80} // Hardcoded to match server spec: firstname = 40, lastname = 40. Better than nothing.
      validationError={validationErrors && validationErrors.name}
    />
    <shared.UsernameInput 
      setValue={setUsername} 
      onBlur={checkUniqueUsername} 
      onEnter={onComplete}
      customError={errors.isUsernameUnique} 
      validationError={validationErrors && validationErrors.username}
    />
    <shared.PasswordInput 
      setValue={setPassword} 
      onEnter={onComplete}
      validationError={validationErrors && validationErrors.password}
    />
    <shared.SelectLanguage onChange={setLanguage} />
  </div>
)

const Major = withSignup(Major_, form.validateMajorStudentSignupForm, {showGoogle: true, userType: "Student"})

const AskAge = createReactClass({
  getInitialState() {
    return {
      submitAttempted: false,
      validationErrors: {}
    }
  },
  onContinue(e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({submitAttempted: true})

    if (this.props.underAge === null) {
      this.showValidationErrors()
      return
    }

    this.props.completeUnderAge()
  },
  showValidationErrors() {
    const validationErrors = {}

    if (this.props.underAge === null) {
      validationErrors.age = "Please select your age range to continue."
    }

    this.setState({validationErrors})
  },
  onAgeSelect(isUnder13) {
    // Clear errors when user makes selection
    this.setState({validationErrors: {}})
    this.props.setUnderAge(isUnder13)
  },
  onAgeChange(e) {
    const isUnder13 = e.target.value === "true"
    this.onAgeSelect(isUnder13)
  },
  handleKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault()
      if (this.props.underAge !== null) {
        this.props.completeUnderAge()
      } else {
        // Show validation error when Enter is pressed but no age is selected
        this.onContinue(e)
      }
    }
  },
  render() {
    const {underAge} = this.props
    return (
      <shared.Subscreen>
        <shared.Textbox>
          <shared.H2 id="age-question">How old are you?</shared.H2>
          <shared.Explanation>This helps protect your privacy.</shared.Explanation>
        </shared.Textbox>
        <fieldset className="border-none p-0 m-0" aria-describedby={this.state.validationErrors.age ? "age-error" : undefined}>
          <legend className="sr-only">Select your age range</legend>
          <div className="grid grid-cols-2 gap-x-4">
            <label className="relative">
              <input type="radio" name="age-range" value="true" checked={underAge === true} onChange={this.onAgeChange} onKeyDown={this.handleKeyDown} className="cursor-pointer absolute inset-0 appearance-none rounded-full peer" />
              <div className="w-full h-12 border-2 border-neutral-17 rounded-full flex items-center justify-center text-neutral-1 font-vs-medium bg-transparent hover:bg-primary-1 hover:text-neutral-20 hover:border-primary-1 peer-checked:border-primary-1 peer-checked:bg-primary-1 peer-checked:text-neutral-20 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-1 focus-within:ring-offset-2">
                I'm 12 or Younger.
              </div>
            </label>
            <label className="relative">
              <input type="radio" name="age-range" value="false" checked={underAge === false} onChange={this.onAgeChange} onKeyDown={this.handleKeyDown} className="cursor-pointer absolute inset-0 appearance-none rounded-full peer" />
              <div className="w-full h-12 border-2 border-neutral-17 rounded-full flex items-center justify-center text-neutral-1 font-vs-medium bg-transparent hover:bg-primary-1 hover:text-neutral-20 hover:border-primary-1 peer-checked:border-primary-1 peer-checked:bg-primary-1 peer-checked:text-neutral-20 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-1 focus-within:ring-offset-2">
                I'm 13 or Older.
              </div>
            </label>
          </div>
        </fieldset>
        {this.state.validationErrors.age && (
          <ErrorMessage id="age-error" className="justify-center !mx-0">
            {this.state.validationErrors.age}
          </ErrorMessage>
        )}
        <shared.Button pressOnEnter={true} onClick={this.onContinue}>
          Continue
        </shared.Button>
      </shared.Subscreen>
    )
  }
})

const renderAskSignupType = (props) => {
  return (
    <shared.Subscreen className="askSignupType">
      <shared.Textbox>
        <shared.H2 id="class-code-question">Do you have a class code?</shared.H2>
        <shared.Explanation>Your teacher may have given you a six digit code. If not, you can log in via Google Classroom.</shared.Explanation>
      </shared.Textbox>
      <div role="group" aria-labelledby="class-code-question" className="grid gap-y-4">
        <shared.Button onClick={() => props.setSignupType(SignupType.CODE)} pressOnEnter={true}>
          Yes, I have a class code
        </shared.Button>
        <shared.Button onClick={() => props.setSignupType(SignupType.GOOGLE)} pressOnEnter={true}>
          No class code
        </shared.Button>
      </div>
    </shared.Subscreen>
  )
}

const renderGoogleSignup = (props) => (
  <shared.Subscreen className="googleSignup">
    <shared.Textbox>
      <shared.H2>Google Sign in</shared.H2>
      <shared.Explanation>
        Your teacher may have set up your Banzai class with Google Sign-in — use the same Google account you use to log into Google Classroom!
      </shared.Explanation>
    </shared.Textbox>
    <ContinueWithGoogle actionType="login" />
    <hr style={hrStyles} />
    <button type="button" className="link-underline text-primary-1 bg-transparent border-none p-0 cursor-pointer" onClick={() => props.setSignupType(SignupType.CODE)}>
      Never mind, I do have a code
    </button>
  </shared.Subscreen>
)

const renderCode = ({onSetCode, completeCode, state, onReset, onFetchedKlass, setSignupType}, hasErrorOverride) => (
  <Code
    codeFromParams={state.code}
    onSetCode={onSetCode}
    onFetchedKlass={onFetchedKlass}
    onCancel={onReset}
    allowContinue={state.klass !== null}
    completeCode={completeCode}
    setSignupType={setSignupType}
    customErrors={[
      [() => hasErrorOverride, () => <div>Oops, something went wrong. Please refresh the screen and try again.</div>],
      [(klass) => klass && klass.deleted, () => <div>Oops, this class no longer exists.</div>],
      [(klass) => klass && klass.archived, () => <div>Oops, this class no longer open.</div>],
      [
        (klass) => klass && klass.course_ids && klass.course_ids.find((e) => e === 1),
        (klass) => (
          <div>
            Oops, <strong>{klass.name}</strong> is a legacy class and has been locked.
          </div>
        )
      ]
    ]}
  />
)

const SignupType = {
  UNKNOWN: 0,
  GOOGLE: 1,
  CODE: 2
}

const ruleMachine = [
  [({signupType}) => signupType === SignupType.UNKNOWN, renderAskSignupType],
  [({signupType}) => signupType === SignupType.GOOGLE, renderGoogleSignup],
  [({signupType, completedCode}) => signupType === SignupType.CODE && !completedCode, renderCode],
  [
    ({klass, completedUnderAge}) => klass && !klass.under_age && !completedUnderAge,
    ({setUnderAge, completeUnderAge, state}) => {
      const {underAge} = state
      return <AskAge underAge={underAge} allowContinue={underAge !== null} setUnderAge={setUnderAge} completeUnderAge={completeUnderAge} />
    }
  ],
  [({klass, underAge}) => (klass && klass.under_age) || underAge, ({completeSignup, state}) => <Minor code={state.code} onComplete={completeSignup} />],
  [
    ({klass, underAge}) => klass && !klass.under_age && !underAge,
    ({completeSignup, state}) => (
      <Major code={state.code} onComplete={completeSignup} />
      // TODO: Code needed here to send to server for google oauth. Should be included in the declaration
      // of this component, but it has no knowledge of top level state, where code is held.
    )
  ],
  [() => true, (state) => renderCode(state, true)]
]

const initialState = (code) => ({
  // signupType: SignupType.UNKNOWN,
  // signupType: SignupType.GOOGLE,
  signupType: SignupType.CODE,
  code: code ? code : null,
  klass: null,
  completedCode: false,
  underAge: null,
  completedUnderAge: false
})

const conformString = (code) => (code ? code : "")

const conformLength = (code) => (code.length === 6 ? code : "")

const conformPattern = (code) => (codePattern.test(code) ? code : "")

const conformUpperCase = (code) => code.toUpperCase()

const conform = (code) => conformUpperCase(conformPattern(conformLength(conformString(code))))

export default createReactClass({
  getInitialState() {
    return assign(initialState(conform(this.props.params.code)), {
      // Test keys allow developer to jump to a spot in the wizard
      // signupType: SignupType.UNKNOWN,
      // signupType: SignupType.GOOGLE,
      // code: "AAA111",
      // klass: {
      //   name: "Test Class",
      //   code: "AAA111",
      //   under_age: false
      // },
      // completedCode: true,
      // underAge: false,
      // completedUnderAge: true
    })
  },
  setSignupType(signupType) {
    this.setState({signupType, completedCode: false, code: null}) // Everytime we set this, lets clear out the code
  },
  completeCode() {
    this.setState({completedCode: true})
  },
  onSetCode(code) {
    this.setState({code, klass: null, completedCode: false}) // Whenever the code is changed, reset verification and completion state.
  },
  onFetchedKlass(klass) {
    this.setState({klass: klass === "not-found" ? null : klass})
  },
  setUnderAge(underAge) {
    this.setState({underAge})
  },
  completeUnderAge() {
    this.setState({completedUnderAge: true})
  },
  completeSignup(user, signalFinished) {
    this.setState(assign({}, user), () => {
      const state = this.state
      const {username, name, password, language} = state
      const userToSubmit = {
        code: state.code,
        under_age: state.underAge,
        first_name: userShared.getFirstName(name),
        last_name: userShared.getLastName(name),
        username: username,
        password: password,
        language: language
      }
      client.completeStudentSignup(userToSubmit, (err, resp) => {
        // TODO: This new logic may need repeated in direct/signup
        if (err) {
          const {response} = err
          if (response && response.status === 422) {
            if (response.body.error === "not-unique") {
              signalFinished({isUsernameUnique: false})
            } else {
              throw new Error("Error on signup for user with 422: " + username)
            }
          } else {
            throw new Error("Unknown error on signup for user: " + username + "; error: " + JSON.stringify(response))
          }
        } else if (resp && resp.status === 200) {
          this.setState({submit: true})
          // Clear any username uniqueness errors on successful signup
          signalFinished({isUsernameUnique: null}) // Clear the error state
        } else {
          throw new Error("Unknown error on signup for user, no response: " + username)
        }
      })
    })
  },
  onReset() {
    this.setState(Object.assign(initialState(), {signupType: this.state.signupType}))
  },
  getCurrentStepAnnouncement() {
    const {signupType, completedCode, klass, completedUnderAge, underAge} = this.state

    if (signupType === SignupType.UNKNOWN) {
      return "Step 1 of 3: Choose signup method"
    } else if (signupType === SignupType.GOOGLE) {
      return "Step 1 of 3: Google signup"
    } else if (signupType === SignupType.CODE && !completedCode) {
      return "Step 1 of 3: Enter class code"
    } else if (klass && !klass.under_age && !completedUnderAge) {
      return "Step 2 of 3: Select your age"
    } else if ((klass && klass.under_age) || underAge) {
      return "Step 3 of 3: Create account for students 12 and under"
    } else if (klass && !klass.under_age && !underAge) {
      return "Step 3 of 3: Create account for students 13 and over"
    }
    return "Student signup"
  },
  render() {
    const {username, password, submit, klass, completedCode} = this.state
    const {code} = this.props.params
    const klassView = klass && completedCode && <Klass klass={klass} onCancel={this.onReset} />
    const stepAnnouncement = this.getCurrentStepAnnouncement()

    return (
      <DocumentTitle title="Sign Up Student: Banzai">
        <shared.Page>
          <shared.Main>
            {/* Step announcement for screen readers */}
            <div role="status" aria-live="polite" className="sr-only">
              {stepAnnouncement}
            </div>
            <div className="md2:flex md2:justify-center md2:items-center md2:gap-x-20 lg:gap-x-[7.5rem]">
              <div>
                <shared.Panel className="klass-code" role="main" aria-label={stepAnnouncement}>
                  {klassView}
                  {shared.showView(ruleMachine, this)}
                  <shared.AlreadyHaveAccount />
                  <shared.HiddenLoginForm submit={submit} username={username} password={password} />
                </shared.Panel>
                <shared.Footer />
              </div>
              <div className="hidden md2:flex flex-col gap-y-6 -mt-20 items-center">
                <Avatar avatar={getAvatar("wink")} size="xl" />
                <div className="title">Already have an account?</div>
                <div>
                  <PrimaryOutlineButton href="/auth#/login">Log In</PrimaryOutlineButton>
                </div>
              </div>
            </div>
          </shared.Main>
        </shared.Page>
      </DocumentTitle>
    )
  }
})
